import { BaseModel } from '../../../models/base-model'
import { Question, UserAnswer, Screen, TestExecution } from '../../models'

export class TestSegment extends BaseModel {
  public testExecution: TestExecution
  public contentType: string
  public question: Question
  public userAnswers: UserAnswer[]
  public screen: Screen
  public metaData: {
    screen: { name: string },
    test: { index: number, length: number },
    questions: { index: number, length: number },
    section: { name: string, type: string, topic: string }
  }

  public get data(): Question | Screen {
    return this[this.contentType] || null
  }

  public isQuestion() {
    return this._dataWithGuaranteedType.type === 'Question'
  }

  public isScreen() {
    return this._dataWithGuaranteedType.type === 'Screen'
  }

  public isSectionMember() {
    return !!this.metaData.section
  }

  public isFirstQuestionInSection(): boolean {
    return this.isQuestion() && this.metaData.section['sgt_index'] === 0
  }

  private get _dataWithGuaranteedType(): BaseModel {
    return (this.data || { type: '', id: '' }) as BaseModel
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-segment/test-segment.ts